import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import SidebarPageLayout from '../../components/layout/SidebarPageLayout';
import Breadcrumbs from '../../components/layout/Breadcrumbs';
import { apiFetch } from '../../api/apiClient';

function scrollToHash(hash) {
  const id = String(hash || '').replace(/^#/, '');
  if (!id) {
    return;
  }
  document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

function SiteTypes() {
  const { hash } = useLocation();
  const [siteTypes, setSiteTypes] = useState([]);
  const [loadError, setLoadError] = useState('');

  useEffect(() => {
    document.title = 'Vivosol Plant Performance Insights Hub | Help / Documentation / Site Types';
  }, []);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        const data = await apiFetch('/api/documentation');
        const nextTypes = Array.isArray(data?.site_types) ? data.site_types : [];
        if (!cancelled) {
          setSiteTypes(nextTypes);
          setLoadError('');
        }
      } catch (apiError) {
        console.warn('API fetch failed for /api/documentation:', apiError);
        if (!cancelled) {
          setSiteTypes([]);
          setLoadError('Unable to load site types.');
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    const timer = window.setTimeout(() => scrollToHash(hash), 0);
    return () => window.clearTimeout(timer);
  }, [hash, siteTypes]);

  return (
    <SidebarPageLayout id="documentation-site-types">
      <div className="content p-5">
        <h1 className="mb-0">Site Types</h1>
        <Breadcrumbs />
        {loadError ? <p className="text-muted mb-0">{loadError}</p> : null}
        <div className="roles">
          {siteTypes.map((siteType) => (
            <section id={siteType.slug || String(siteType.type_id)} key={siteType.type_id} className="role">
              <h2>{siteType.label}</h2>
              {siteType.description ? <p>{siteType.description}</p> : null}
            </section>
          ))}
        </div>
      </div>
    </SidebarPageLayout>
  );
}

export default SiteTypes;
